import axios from 'axios';
import { defaultTo } from 'lodash';

const http = axios.create({
  timeout: 5000,
});

const platforms = {
  seven: async (config) => {
    try {
      const response = await http.post(config.endpoint, {
        id: config.id,
        token: config.token,
      }, {
        headers: config.headers,
      });

      return response;
    } catch (error) {
      return error.response.data;
    }
  },
};

export default {
  async thirdPartyUser(config) {
    const data = await platforms[config.platformName](config);

    return defaultTo(data, {
      success: false,
      message: 'ACTION_ERROR',
      details: {
        playerToken: undefined,
      },
    });
  },
};
